const path = '/img/solutions/entertainment';

export const BANNER = {
  title: '泛娱乐场景解决方案',
  description:
    '依托点播、直播、实时音视频互动等标准化产品，辅以丰富的互动玩法、媒体处理能力和场景化AI产品，构建泛娱乐行业从内容生产到内容消费的全链路解决方案，帮助客户快速搭建泛娱乐业务',
  buttonText: '立即咨询',
  backgroundImg: `${path}/banner.webp`,
  backgroundImgMobile: `${path}/bannerMobile.webp`,
  docText: '产品文档',
};

export const ARCHITECTURE = {
  title: '方案架构',
  picUrl: `${path}/architecture.webp`,
};

export const ADVANTAGES = {
  title: '方案优势',
  details: [
    {
      title: '一站式服务，满足多场景',
      content:
        '支持多终端，SDK及组件化灵活输出、适配不同需求\n提供生产组件、互动特效、一键成片等视频生产能力，降低视频制作门槛、助力客户创作生态',
      iconUrl: `${path}/icon1.webp`,
    },
    {
      title: '全链路分析决策',
      content:
        '机型画像中心：海量机型数据为基础，真正实现“千机变”\n 热度决策中心：合理决策转码方式、优化转码ROI\n 网络画像中心：综合考量网络质量，提升播放质量',
      iconUrl: `${path}/icon2.webp`,
    },
    {
      title: '领先的AI算法，保障社区环境',
      content:
        '提供内容查重、内容标签、内容审核、内容检索等众多视频内容理解能力\n 基于深度学习算法及海量标签体系，快速结构化视频兴趣标签，辅助实现个性化推荐策略',
      iconUrl: `${path}/icon3.webp`,
    },
    {
      title: '数据驱动',
      content:
        '全链路质量监控体系，为线上服务稳定性保驾护航\n支持AB实验，通过数据指标表现指导各环节的优化策略选择',
      iconUrl: `${path}/icon4.webp`,
    },
  ],
};

export const USECASE = {
  title: '使用场景',
  items: [
    {
      title: '视频社区',
      subTitle:
        '视频社区方案提供了安全存储、智能处理、内容审核、内容分发、播放器SDK等产品和能力，帮助客户快速搭建短视频社区业务，提供最佳消费体验',
      picUrl: `${path}/usecase1.webp`,
    },
    {
      title: '互动直播',
      subTitle:
        '自研LAS传输协议，保障直播传输质量和直播链路的稳定\n丰富的直播互动玩法和美颜特效，增加直播趣味性',
      picUrl: `${path}/usecase2.webp`,
    },
  ],

  picUrl: `${path}/peitu.webp`,
};

export const NAV = ['方案架构', '方案优势', '使用场景', '客户案例'];

export const BRAND = {
  title: '客户案例',
  items: ['快手', 'AcFun', '知乎', '多多视频', '拉拉公园'],
};
